import React, { useState } from 'react';
import { Popup, Button, Checkbox, Icon, Grid, List, Divider } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import { designActions } from '../../actions';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import SlideShow from '../SlideShow/SlideShow';
import _ from 'lodash';
import './DesignItem.css';

const DesignItem = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  let { width, height } = props.photo;
  const [editable, setEditable] = useState(false);
  const [open, setOpen] = useState(false);
  const srcSet = [props.photo.src];

  for (let i = 1; i < _.get(props.photo, 'data.pagesCount', 1); i++) {
    const previewVersion = _.get(props.photo, 'data.previewVersion');
    srcSet.push(
      `${process.env.REACT_APP_FILE_SERVER}/resources/designs/${props.photo.data.id}-${i +
        1}/thumbnail.png${previewVersion ? `?v=${previewVersion}` : ''}`,
    );
  }

  if (height > 250) {
    width = (width * 250) / height;
    height = 250;
  }

  const duplicateDesign = () => {
    setOpen(false);
    dispatch(designActions.duplicate(props.photo.data.id, props.index));
  };

  const deleteDesign = () => {
    setOpen(false);
    dispatch(designActions.deleteDesign(props.photo.data.id));
  };

  return (
    <div key={props.index} className="item-box" style={{ ...props.cont }}>
      <div className="design-image">
        <SlideShow
          alt={props.photo.title}
          style={{ ...props.imgStyle }}
          onClick={() => props.onClick(props.photo.data.id)}
          {...props.photo}
          width={width}
          height={height}
          srcSet={srcSet}
        />
        <div className="button-more transition">
          <Popup
            className="popup"
            on="click"
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            basic
            trigger={<Button icon="ellipsis horizontal" />}
          >
            <Popup.Content>
              <Grid>
                <Grid.Column floated="right">
                  {props.photo.data.name || t('untitledDesign')}
                </Grid.Column>
              </Grid>
              <Divider />
              <List relaxed verticalAlign="middle">
                <List.Item as="a" onClick={duplicateDesign}>
                  <List.Icon name="copy outline" />
                  <List.Content>
                    <List.Header content={t('getCopy')} />
                  </List.Content>
                </List.Item>
                {/* <List.Item as="a" disabled>
                  <List.Icon name="folder outline" />
                  <List.Content>
                    <List.Header content={t('moveToFolder')} />
                  </List.Content>
                </List.Item>
                <List.Item as="a" disabled>
                  <List.Icon name="download" />
                  <List.Content>
                    <List.Header content={t('download')} />
                  </List.Content>
                </List.Item>
                <List.Item as="a" disabled>
                  <List.Icon name="linkify" />
                  <List.Content>
                    <List.Header content={t('getSharedLink')} />
                  </List.Content>
                </List.Item> */}
                <List.Item as="a" onClick={deleteDesign}>
                  <List.Icon name="trash alternate outline" />
                  <List.Content>
                    <List.Header content={t('moveToDelete')} />
                  </List.Content>
                </List.Item>
              </List>
            </Popup.Content>
          </Popup>
        </div>
        <div className="design-checked transition">
          <Checkbox />
        </div>
      </div>
      <div className="design-name">
        {editable ? (
          <input type="text" value={props.photo.data.name || t('untitledDesign')} />
        ) : (
          <>
            <span onClick={() => setEditable(true)}>
              {props.photo.data.name || t('untitledDesign')}
            </span>
            <Icon name="pencil" onClick={() => setEditable(true)} />
          </>
        )}
      </div>
    </div>
  );
};

DesignItem.propTypes = {
  index: PropTypes.number,
  photo: PropTypes.any,
  cont: PropTypes.any,
  imgStyle: PropTypes.any,
  onClick: PropTypes.func,
};

export default DesignItem;
